<template>
  <div>

    <textarea
      :class="{'form-control': true, border: true, 'border-danger': error!='', 'border-success':error==''}"
      v-model="jsonString">

    </textarea>
    <div class="alert alert-danger" v-if="error!=''">
      {{error}}
    </div>
    <button class="btn btn-sm btn-secondary" @click="doValidate">Validate</button>
  </div>
</template>

<script>
  export default {
    name: "json-textfield",
    props: ['json'],
    data() {
      return {
        jsonString: '',
        message: '',
        error: ''
      }
    },
    created() {
      this.jsonString = JSON.stringify(this.$props.json, null, ' ');
    },
    methods: {
      getData() {
        try {
          this.validate();
          return JSON.parse(this.jsonString);
        } catch (e) {
          throw new Error(e);
        }
      },
      doValidate() {
        try {
          this.validate();
        } catch (e) {
        }
      },
      validate() {
        try {
          this.jsonString = JSON.stringify(JSON.parse(this.jsonString), null, ' ');
          this.error = '';
        } catch (e) {
          this.error = e.toString();
          throw new Error(e);
        }
      }
    }
  }
</script>

<style scoped>
  textarea {
    font-family: monospace;
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
    min-height: 5rem;
    height: 15rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/JsonTextfield.vue